import PT from 'prop-types';
import React from 'react';
import { Link as RouterLink } from 'react-router';

import { TruncateText } from '~/eds/src/components/Text/subcomponents/TruncateText';
import { Text } from '~/eds/src/components/Text/Text';
import styles from '~/ui/styles';
import theme from '~/ui/theme';

import { EDS_ACTION_COLOR } from '../../constants/colors';

export default function Link({
  children,
  disabled = false,
  href,
  id,
  shouldTruncate = false,
  shouldWrap = false,
  target = '_self',
  to,
  variant,
  onClick,
}) {
  let as;
  if (to) {
    // uinix `as` must be a string or render function — not a component object.
    as = (props, linkChildren) => (
      <RouterLink {...props}>{linkChildren}</RouterLink>
    );
  } else if (href) {
    as = 'a';
  } else {
    as = 'span';
  }

  const TextComponent = shouldTruncate ? TruncateText : Text;

  return (
    <TextComponent
      as={as}
      color={EDS_ACTION_COLOR}
      disabled={disabled}
      href={href}
      id={id}
      styles={{
        textDecoration: 'none',
        whiteSpace: shouldWrap ? 'normal' : undefined,
        minWidth: 0,
        ...styles.interactions.clickable,
      }}
      target={target}
      to={to}
      variant={variant}
      onClick={onClick}
    >
      {children}
    </TextComponent>
  );
}

Link.propTypes = {
  /** React child */
  children: PT.node,
  /** Disables the link */
  disabled: PT.bool,
  /** If provided, render as an anchor link */
  href: PT.string,
  /** Element ID */
  id: PT.string,
  /** If link should be truncated if it exceeds the parent width */
  shouldTruncate: PT.bool,
  /** If link text should wrap if it exceeds the parent width */
  shouldWrap: PT.bool,
  /** If provided, render as a router Link */
  to: PT.string,
  /** Text variant */
  variant: PT.oneOf(Object.keys(theme.text)),
  /** Click handler.  For accessibility and semantics, avoid using this if either `href` or  the `to` prop is specified.  */
  onClick: PT.func,
};
